import { EnrollmentId } from 'types/enrollment/enrollment';

export const ENROLLMENT = (enrollmentId: EnrollmentId) =>
    `/api/v1/enrollment/for-parent/${enrollmentId}`;
